module.exports = __webpack_public_path__ + "img/temperature_gray.ede53b22.svg";